import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'moment/locale/pt-br'
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import { alterarTipoAjusteItinerarioEmLote } from '../../actions/itinerario/alterarTipoAjusteItinerarioEmLote'
import {
    renderFieldCheck,
    renderFieldHora,
    renderFieldNumeros,
    renderFieldNumerosPorcentagem,
    renderFieldSelect,
    required,
    requiredSelect,
    tamanhoHoraMinuto,
    tamanhoPorcentagem,
    validateHora,
    validateMinutos
} from '../../util/inputs';
import { showAlertMsg, showSuccessMsg } from '../../util/messagesUtil';
import { tipoAjusteItinerario, tiposConfiguracoesPreco } from '../../util/constantsUtil';


registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');


export class ModalAlteracaoTipoAjusteItinerarioEmLote extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.state = { dataInicio: null, dataFim: null }
    }

    montarParametroItinerario(values) {
        let tipoAjuste = this.props.exibirAjuste && values.tipoAjusteItinerario ? values.tipoAjusteItinerario.value : null;
        let valorAjuste = this.props.exibirAjuste && values.valorAjuste ? values.valorAjuste.replace('R$', '') : '0';
        let tipoConfiguracaoPreco = null;
        let horaPartidaRegra = null;
        let quantidadePoltronasRegra = null;
        if (values.exibirAjuste) {
            tipoAjuste = values.tipoAjusteItinerario.value;
            tipoConfiguracaoPreco = values.tipoConfiguracaoPreco.value;
            valorAjuste = values.valorAjuste ? values.valorAjuste.replace('R$', '') : '0';
            if (tipoConfiguracaoPreco === 'DATA_PARTIDA') {
                horaPartidaRegra = values.horaPartidaRegra;
            }
            if (tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_CADA' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_A_PARTIR' ||
                tipoConfiguracaoPreco === 'POLTRONAS_VENDIDAS_ATE_NUMERO') {
                quantidadePoltronasRegra = values.quantidadePoltronasRegra;
            }
            if (tipoConfiguracaoPreco !== 'POR_USUARIO') {
                this.props.limparPricePorUsuario();
            }
        }
        return {
            dataInicio: moment(this.state.dataInicio).format('YYYY-MM-DD'),
            dataFim: moment(this.state.dataFim).format('YYYY-MM-DD'),
            empresaId: this.props.empresaSelecionada.id,
            idRota: this.props.rotaSelecionada.value,
            valorAjuste,
            tipoAjuste,
            tipoConfiguracaoPreco,
            horaPartidaRegra,
            quantidadePoltronasRegra,
            pricePorUsuarioEmpresa: this.props.vendedoresSelecionados.map(it => {
                return {
                    tipoAjuste: it.tipoAjusteItinerario.value,
                    valorAjuste: it.valorAjuste,
                    tipoConifguracaoPreco: it.tipoConfiguracaoPreco ? it.tipoConfiguracaoPreco.value : 'POR_USUARIO',
                    usuarioId: it.id,
                }
            })

        }
    }

    fecharModal() {
        $('#modalAlteracaoTipoAjusteItinerarioEmLote')
            .modal('hide');
        $('#modalAlteracaoTipoAjusteItinerarioEmLote')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    submit(values) {
        const parametros = this.montarParametroItinerario(values);
        this.props.alterarTipoAjusteItinerarioEmLote(parametros)
            .then(() => {
                showSuccessMsg('Operação realizada com sucesso');
                this.fecharModal();
                this.props.buscarItinerarios();
            })
    }


    limparFormulario() {
        this.props.reset('formularioAlteracaoTipoAjustePorPeriodo');
        this.setState({ dataInicio: null, dataFim: null });
        this.props.limparPricePorUsuario();
    }


    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({ dataInicio: data, dataFim: null })
        } else {
            this.setState({ data, dataFim: data })
        }
    }


    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 5)
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    handleExibirCamposAjusteValor(evento) {
        if (evento.target.value) {
            this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
                'valorAjuste', '');
            this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
                'tipoAjusteItinerario', '');
        }
        this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
            'exibirAjuste', evento.target.value);
    }

    exibirUsuariosVendedoresSelecionados() {
        return <table className="table table-sm table-bordered">
            <thead>
                <tr className='text-center'>
                    <th colSpan='5'>Vendedores</th>
                </tr>
                <tr>
                    <th>ID</th>
                    <th>Desconto/Acréscimo</th>
                    <th>Valor(%)</th>
                    <th>Descricao</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                {!this.props.vendedoresSelecionados || this.props.vendedoresSelecionados.length === 0 ?
                    <tr className="alert alert-warning text-center mt-4" role="alert">
                        <td colSpan='5'>Nenhum vendedor foi
                            cadastrado.
                        </td>
                    </tr>
                    :
                    this.props.vendedoresSelecionados
                        .map((vendedor) => <tr key={vendedor.id}>
                            <td>
                                {vendedor.id}
                            </td>                            
                            <td>
                                {vendedor.tipoAjusteItinerario.label}
                            </td>
                            <td>
                                {vendedor.valorAjuste}
                            </td>
                            <td>
                                {vendedor.vendedor.label}
                            </td>
                            <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                <div
                                    onClick={() => this.props.removerUsuarioVendedor(vendedor.id)}
                                    >Remover
                                </div>
                            </td>
                        </tr>)}
            </tbody>
        </table>        
    }

    exibirAjuste() {
        if (this.props.exibirAjuste) {
            return <React.Fragment>
                <div className="col-12 col-sm-3 col-md-3">
                    <Field name='tipoAjusteItinerario'
                        options={tipoAjusteItinerario.map(elemento => ({
                            descricao: elemento.label,
                            nome: elemento.value
                        }))}
                        component={renderFieldSelect}
                        label="Descontos/Acréscimos"
                        placeholder='Selecione um tipo' validate={requiredSelect} />
                </div>
                <div className="col-12 col-sm-2 col-md-2">
                    <Field name='valorAjuste' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="Desconto/Acréscimo(%):" />
                </div>
                <div className="col-12 col-sm-5 col-md-5">
                    <Field name='tipoConfiguracaoPreco'
                        options={tiposConfiguracoesPreco.map(elemento => ({
                            descricao: elemento.label,
                            nome: elemento.value
                        }))}
                        component={renderFieldSelect}
                        label="Regra de desconto/acréscimo"
                        validate={requiredSelect} />
                </div>
                {this.props.tipoConfiguracaoPreco && this.props.tipoConfiguracaoPreco.value === 'DATA_PARTIDA' ?
                    <React.Fragment>
                        <div className="col-12 col-sm-2 col-md-2">
                            <Field name="horaPartidaRegra"
                                css='form-control'
                                component={renderFieldHora}
                                label="Hora"
                                validate={[required, validateMinutos, validateHora, tamanhoHoraMinuto]} />
                        </div>
                    </React.Fragment> : ''}

                {this.props.tipoConfiguracaoPreco && (this.props.tipoConfiguracaoPreco.value === 'POLTRONAS_VENDIDAS_A_CADA' || this.props.tipoConfiguracaoPreco.value === 'POLTRONAS_VENDIDAS_A_PARTIR' || this.props.tipoConfiguracaoPreco.value === 'POLTRONAS_VENDIDAS_ATE_NUMERO') ?
                    <React.Fragment>
                        <div className="col-12 col-sm-2 col-md-2 mt-2">
                            <label>Número de poltronas</label>
                            <Field name="quantidadePoltronasRegra" type="text" component={renderFieldNumeros}
                                valor={this.props.quantidadePoltronasRegra}
                                formatacao='##'
                                css="form-control" />
                        </div>
                    </React.Fragment> : ''}

                {this.props.tipoConfiguracaoPreco && this.props.tipoConfiguracaoPreco.value === 'POR_USUARIO' ? <>
                    <div className="col-12 col-sm-5 col-md-5">                           
                        <Field name='vendedores'
                            options={this.props.usuariosVendedores.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            component={renderFieldSelect}
                            label="Adicionar Usuarios Vendedores"
                            placeholder='Selecione um usuário'                                 
                        />
                    </div>
                    <div className="col-12 col-sm-3 col-md-2" style={{marginTop: '2.2rem'}}>
                        <button
                            type="submit" className="btn btn-sm btn-laranja"
                            onClick={(e) => this.adicionarPricePorUsuario(e)}
                            >Incluir
                        </button>
                    </div>
                    <div className="col-12 col-sm-12 col-md-10 mt-2">
                        <div className="lista-table">
                            {this.exibirUsuariosVendedoresSelecionados()}
                        </div>
                    </div>
                </>:''}


            </React.Fragment>
        }
    }

    adicionarPricePorUsuario(event) {
        event.preventDefault();        
        if (!this.props.valorAjuste) {
            showAlertMsg('Informe o valor.');
            return;
        }
        if (!this.props.tipoAjusteItinerario) {
            showAlertMsg('Informe o desconto/acréscimo.');
            return;
        }
        if (!this.props.vendedores) {
            showAlertMsg('Informe o usuário.');
            return;
        }
        const obj = {id: this.props.vendedores.value, vendedor: this.props.vendedores, valorAjuste: this.props.valorAjuste, 
            tipoAjusteItinerario: this.props.tipoAjusteItinerario, tipoConfiguracaoPreco: this.props.tipoConfiguracaoPreco };
        this.props.adicionarPricePorUsuario(obj);
        this.props.changeFieldValue('formularioAlteracaoTipoAjustePorPeriodo',
            'vendedores', null);        
    }


    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalAlteracaoTipoAjusteItinerarioEmLote' role='dialog'
                aria-labelledby='modalAlteracaoTipoAjusteItinerarioEmLote' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Alterar desconto/acréscimo em lote</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Período de alteração</legend>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data de início</label>
                                        {this.exibirCalendario(true)}
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-2 mt-2">
                                        <label>Data fim</label>
                                        {this.exibirCalendario()}
                                    </div>
                                </fieldset>
                                <fieldset className="scheduler-border">
                                    <legend className="scheduler-border">Configuração de preço</legend>
                                    <div className="col-12 col-sm-12 col-md-12">
                                        <Field type="checkbox" name='exibirAjuste' component={renderFieldCheck}
                                            label="Incluir desconto ou acréscimo na passagem"
                                            css="form-check-input" readOnly={false}
                                            onChange={e => this.handleExibirCamposAjusteValor(e)} />
                                    </div>
                                    {this.exibirAjuste()}
                                </fieldset>
                                <div className="modal-footer">
                                    <button type="submit"
                                        disabled={invalid || submitting || !this.state.dataInicio
                                            || !this.state.dataFim}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            tipoConfiguracaoPreco: { label: 'Normal', value: 'NORMAL' }
        },
        exibirAjuste: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'exibirAjuste'),
        vendedores: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'vendedores'),
        valorAjuste: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'valorAjuste'),
        tipoAjusteItinerario: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'tipoAjusteItinerario'), 
        tipoConfiguracaoPreco: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'tipoConfiguracaoPreco'),
        horaPartidaRegra: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'horaPartidaRegra'),
        quantidadePoltronasRegra: formValueSelector('formularioAlteracaoTipoAjustePorPeriodo')(state, 'quantidadePoltronasRegra'),
        empresaSelecionada: state.empresaSelecionada,
        rotaSelecionada: state.rotaSelecionada,
        usuariosVendedores: state.usuariosVendedores

    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        alterarTipoAjusteItinerarioEmLote,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAlteracaoTipoAjustePorPeriodo',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalAlteracaoTipoAjusteItinerarioEmLote));
